<template>
    <section class="textSection">
        <div>
            <h1>Récupération</h1>
            <div v-if="valid">
                <p v-if="submitted" style="margin-left: 150px;">Votre mot de passe a bien été modifié</p>
                <form v-if="!submitted" class="recover-form" v-on:submit.prevent="edit_password()">
                    <div class="recover-container">
                        <div v-if="error || different" class="recover-errors">
                            <p v-if="different" class="recover-error">Les mots de passe ne correspondent pas</p>
                            <p v-if="error" class="recover-error">Le mot de passe doit contenir plus de 6 caractères</p>
                        </div>
                        <label class="recover-label" for="password">Nouveau mot de passe *</label>
                        <input class="recover-input" :style="[error === true ? {'border-color': 'red'} : '']" v-model="password" type="password" placeholder="********" required="required" aria-required="true" id="password">
                        <label class="recover-label" for="password-completion">Confirmer mot de passe *</label>
                        <input class="recover-input" :style="[error === true ? {'border-color': 'red'} : '']" v-model="password_confirmation" type="password" placeholder="********" required="required" aria-required="true" id="password-completion">
                    </div>
                    <button class="recover" type="submit">Changer le mot de passe</button>
                </form>
            </div>
            <div v-else>
                <p style="margin-left: 150px;">Ce lien est invalide ou a expiré.</p>
            </div>
        </div>
    </section>
</template>

<script>
    import AuthenticationService from '../services/authentication.js'
    export default {
        name: "PasswordRecovery",
        data: function () {
            return {
                password: null,
                password_confirmation: null,
                submitted: false,
                error: false,
                different: false,
                valid: true,
            }
        },
        created: function () {
            this.getToken();
        },

        methods: {
            edit_password: function () {
                this.error = this.password.length < 6;
                this.different = this.password !== this.password_confirmation;
                if (this.different || this.error) return;
                AuthenticationService.editPassword({
                    password: this.password,
                    user_id: this.$route.params.userId,
                    token: this.$route.params.token
                }).then((res) => {
                    this.submitted = true;
                }, (res) => {
                    this.submitted = false;
                });
            },
            getToken: function () {
                AuthenticationService.getToken({
                    user_id: this.$route.params.userId,
                    token: this.$route.params.token
                }).then((res) => {

                }, (res) => {
                    this.valid = false
                    console.warn(res)
                })
            }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// PasswordRecovery.vue?1da3829c